<template minapp='mpx' xlang='wxml'>
  <view class="card-container">
    <view catchtap="clickItem" class="card-box {{touchMoveActive}}">
      <view class="del" catchtap="delItem">
        <slot name="delContext" wx:if="{{isShowDel}}"></slot>
      </view>
      <view class="card"   bindtouchstart="touchStart" bindtouchmove="touchMove" bindtouchend="touchEnd" >
        <slot name="mainContext"></slot>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import currentMixin from './functional.js'
  createComponent({
    mixins: [currentMixin],
    props: {
      isActive:{
        type: Boolean,
        value: false
      },
      item: {
        type: Object,
        value: {}
      }
    },
    
    computed: {
      touchMoveActive() {
        return this.isTouchMove?'touch-move-active':''
      },
    },
    watch: {
      isActive (val) {
        this.isTouchMove = val;
      },
      isTouchMove(val){
        if(val){
          this.isShowDel = val;
        }else{
          setTimeout(() => {
            this.isShowDel = val;
          }, 400);
        }
      }
    },
    data() {
      return {
        startX: 0, //开始坐标
        startY: 0,
        isTouchMove:false,
        isShowDel:false,
      }
    },
    methods: {
      delItem(){
        this.$trigger('click-right',this.item)
        this.isTouchMove = false
      },
      clickItem(){
        this.isTouchMove?this.isTouchMove=false:this.$trigger('click-left',this.item)
      }
    },
    pageLifetimes: {
      hide: function () {
        this.isTouchMove = false
      },
    },
  })
</script>

<style scoped lang="stylus" scoped>
  .card-container{
    flex:1;
    border-radius: 16rpx;
  }
  .card-box{
    display: flex;
    overflow: hidden;
    justify-content: flex-start;
    flex-direction:row-reverse;
  }
  .card{
    display:flex;
    justify-content: space-between;
    flex-direction:column;
    transform: translateX(264rpx)
    transition: all 0.4s;
    margin-left: -260rpx;
    width:100%;
  }
  .touch-move-active .card{
    transform: translateX(106rpx)
    transition: all 0.4s;
  }
  .del{
    color: #fff;
    overflow: hidden;
    width:260rpx;
    box-sizing: border-box;
    margin:2rpx;
  }
</style>
<script name='json'>
module.exports = {
    component: true,
  'usingComponents': {
  }
}
</script>
